<template>
  <div class="coupon">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow title="使用优惠券" @click-left="onClickLeft" />
    <!-- 内容 -->
    <div class="kqb-coupon-list">
      <div class="kqb-coupon-item BGurl-coupon-card1">
        <div class="tips BGurl-coupon-card-tips1">2天后到期</div>
        <div class="kqb-coupon-head ellipsis">全聚德烤鸭优惠券</div>
        <div class="kqb-coupon-content">
          <div class="kqb-coupon-label">
            <span><span>50</span>元</span>
            <span>满600立减</span>
          </div>
          <div class="kqb-coupon-inner">
            北京烤鸭专用，满600减50元 仅限客渠邦小程序内使用
          </div>
        </div>
        <div class="kqb-counpon-footer">
          <span class="date">有效期至2018-12-30</span>
          <button class="kqb-btn bc-CA9A58">立即使用</button>
        </div>
      </div>
      <div class="kqb-coupon-item BGurl-coupon-card2">
        <div class="tips BGurl-coupon-card-tips2">2天后到期</div>
        <div class="kqb-coupon-head ellipsis">全聚德烤鸭优惠券</div>
        <div class="kqb-coupon-content">
          <div class="kqb-coupon-label">
            <span><span>50</span>元</span>
            <span>满600立减</span>
          </div>
          <div class="kqb-coupon-inner">
            北京烤鸭专用，满600减50元 仅限客渠邦小程序内使用
          </div>
        </div>
        <div class="kqb-counpon-footer">
          <span class="date">有效期至2018-12-30</span>
          <button class="kqb-btn bc-BBBBBB">立即使用</button>
        </div>
      </div>
      <div class="kqb-coupon-item BGurl-coupon-card3">
        <div class="tips BGurl-coupon-card-tips3">2天后到期</div>
        <div class="kqb-coupon-head ellipsis">全聚德烤鸭优惠券</div>
        <div class="kqb-coupon-content">
          <div class="kqb-coupon-label">
            <span><span>50</span>元</span>
            <!-- <span>满600立减</span> -->
          </div>
          <div class="kqb-coupon-inner">
            北京烤鸭专用，满600减50元 仅限客渠邦小程序内使用
          </div>
        </div>
        <div class="kqb-counpon-footer">
          <span class="date">有效期至2018-12-30</span>
          <button class="kqb-btn bc-F1574D">立即使用</button>
        </div>
      </div>
      <div class="kqb-coupon-item BGurl-coupon-card4">
        <div class="tips BGurl-coupon-card-tips3">2天后到期</div>
        <div class="kqb-coupon-head ellipsis">全聚德烤鸭优惠券</div>
        <div class="kqb-coupon-content">
          <div class="kqb-coupon-label">
            <span><span>50</span>元</span>
            <span>满600立减</span>
          </div>
          <div class="kqb-coupon-inner">
            北京烤鸭专用，满600减50元 仅限客渠邦小程序内使用
          </div>
        </div>
        <div class="kqb-counpon-footer">
          <span class="date">有效期至2018-12-30</span>
          <button class="kqb-btn bc-F1574D">立即使用</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'coupon',
  data () {
    return {
      message: '',
      // fileList: [
      //   { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
      //   // Uploader 根据文件后缀来判断是否为图片文件
      //   // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
      //   { url: 'https://cloud-image', isImage: true }
      // ]
      fileList: []
    }
  },
  created () {

  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    submitFeedback () { }
  }
}
</script>
<style scoped>
.myCardPackage {
  background: #f8fbff;
}
.kqb-coupon-list {
  padding: 0 36px 60px 36px;
}

.kqb-coupon-item {
  height: 320px;
  margin: 40px 0 0 0;
}

.tips {
  z-index: 11;
  position: absolute;
  top: 8px;
  right: -3px;
  width: 162px;
  height: 65px;
  line-height: 65px;
  text-align: center;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}

.tips.BGurl-coupon-card-tips1 {
  color: rgba(191, 98, 41, 1);
}

.tips.BGurl-coupon-card-tips2 {
  color: rgba(187, 187, 187, 1);
}

.tips.BGurl-coupon-card-tips3 {
  color: rgba(220, 58, 45, 1);
}

.kqb-coupon-head,
.kqb-coupon-content {
  text-align: left;
  padding: 0 22px 0 50px;
}

.kqb-coupon-head {
  padding: 27px 22px 35px 50px;
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.kqb-coupon-content {
  display: flex;
}

.kqb-coupon-content .kqb-coupon-label {
  display: flex;
  flex-direction: column;
  text-align: left;
  min-width: 189px;
  font-size: 28px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 53px;
}

.kqb-coupon-content .kqb-coupon-inner {
  padding: 12px 0 0 43px;
  line-height: 44px;
}
.kqb-coupon-content .kqb-coupon-inner::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 72px;
  border-left: 1px solid #fff;
  transform: translate(0, -50%);
}
.kqb-coupon-content .kqb-coupon-label span:first-child span {
  font-size: 80px;
}

.kqb-coupon-content .kqb-coupon-inner {
  font-size: 28px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.kqb-counpon-footer {
  position: absolute;
  bottom: 22px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px 0 15px;
}

.kqb-counpon-footer .date {
  font-size: 28px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.kqb-counpon-footer .kqb-btn {
  width: 134px;
  height: 46px;
  line-height: 46px;
  padding: 0;
  text-align: center;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: transparent;
  border: 1px solid transparent;
  border-radius: 23px;
}

.kqb-counpon-footer .kqb-btn.bc-F1574D {
  border-color: rgba(241, 87, 77, 1);
  color: rgba(241, 87, 77, 1);
}

.kqb-counpon-footer .kqb-btn.bc-BBBBBB {
  border-color: rgba(187, 187, 187, 1);
  color: rgba(187, 187, 187, 1);
}

.kqb-counpon-footer .kqb-btn.bc-CA9A58 {
  border-color: rgba(202, 154, 88, 1);
  color: rgba(202, 154, 88, 1);
}

.kqb-counpon-footer .kqb-btn.bc-F1574D.button-hover,
.kqb-counpon-footer .kqb-btn.bc-CA9A58.button-hover {
  background: transparent;
}
</style>
